import styled from 'styled-components';
import { formContainerStyles, formGroupStyles } from '../style';

export const RegisterStyles = styled.div`
  .register-container {
    ${formContainerStyles}
  }

  ${formGroupStyles}

  .form-label {
    display: flex;
    gap: 10px;
  }
`;
